<div
  class="kl-field"
  [class.kl-field--my-3]="marginY()"
  [class.kl-field--mb-2]="marginBottom()"
  [formGroup]="formGroup()">
  @if (label()) {
    <kl-label
      [label]="label()"
      [labelDescription]="labelDescription()"
      [isRequired]="required()"
      [htmlFor]="fieldId()" />
  }

  <div #fieldControl class="kl-field__control text-start">
    @if (bindWholeObject()) {
      <p-select
        [inputId]="fieldId()"
        [options]="options()"
        [optionLabel]="optionLabel()"
        [dataKey]="dataKey()"
        [placeholder]="placeholder() | translate"
        [filter]="filter()"
        [filterBy]="secondaryOptionLabel() ? optionLabel() + ',' + secondaryOptionLabel() : undefined"
        [showClear]="showClear()"
        [appendTo]="appendTo()"
        [panelStyle]="matchPanelToTriggerWidth() ? panelOverlayStyle() : null"
        panelStyleClass="kl-select-overlay-panel"
        [formControlName]="controlName()"
        [loading]="loading()"
        [fluid]="fluid()"
        [invalid]="showInvalid()"
        (onShow)="onSelectOverlayShow()"
        (onHide)="onSelectOverlayHide()"
        (onChange)="onAnyChange()">
        @if (secondaryOptionLabel(); as secondaryField) {
          <ng-template let-item pTemplate="item">
            {{ item[optionLabel()] }}{{ item[secondaryField] ? ' - ' + item[secondaryField] : '' }}
          </ng-template>
          <ng-template let-item pTemplate="selectedItem">
            @if (item) {
              {{ item[optionLabel()] }}{{ item[secondaryField] ? ' - ' + item[secondaryField] : '' }}
            }
          </ng-template>
        } @else if (translateOptionLabels()) {
          <ng-template let-item pTemplate="item">{{ item[optionLabel()] | translate }}</ng-template>
          <ng-template let-item pTemplate="selectedItem">
            @if (item) {
              {{ item[optionLabel()] | translate }}
            }
          </ng-template>
        }
      </p-select>
    } @else {
      <p-select
        [inputId]="fieldId()"
        [options]="options()"
        [optionLabel]="optionLabel()"
        [optionValue]="optionValue()"
        [placeholder]="placeholder() | translate"
        [filter]="filter()"
        [filterBy]="secondaryOptionLabel() ? optionLabel() + ',' + secondaryOptionLabel() : undefined"
        [showClear]="showClear()"
        [appendTo]="appendTo()"
        [panelStyle]="matchPanelToTriggerWidth() ? panelOverlayStyle() : null"
        panelStyleClass="kl-select-overlay-panel"
        [formControlName]="controlName()"
        [loading]="loading()"
        [fluid]="fluid()"
        [invalid]="showInvalid()"
        (onShow)="onSelectOverlayShow()"
        (onHide)="onSelectOverlayHide()"
        (onChange)="onAnyChange()">
        @if (secondaryOptionLabel(); as secondaryField) {
          <ng-template let-item pTemplate="item">
            {{ item[optionLabel()] }}{{ item[secondaryField] ? ' - ' + item[secondaryField] : '' }}
          </ng-template>
          <ng-template let-item pTemplate="selectedItem">
            @if (item) {
              {{ item[optionLabel()] }}{{ item[secondaryField] ? ' - ' + item[secondaryField] : '' }}
            }
          </ng-template>
        } @else if (translateOptionLabels()) {
          <ng-template let-item pTemplate="item">{{ item[optionLabel()] | translate }}</ng-template>
          <ng-template let-item pTemplate="selectedItem">
            @if (item) {
              {{ item[optionLabel()] | translate }}
            }
          </ng-template>
        }
      </p-select>
    }
  </div>

  <div class="kl-field__error text-start">
    @if (showFieldError() && controlError()) {
      <span>{{ controlError() }}</span>
    }
  </div>
</div>
